import React, { Component } from 'react';
import { Tabs, Tooltip, Icon, Button, Spin } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import { View, ExportModal } from './Widget';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';
import moment from 'moment';

const { TabPane } = Tabs;
const monthFormat = 'YYYY-MM';

const splitParams = (params) => {
    const result = {};
    for (let [key, value] of Object.entries(params)) {
        const type = typeof value;
        if (type !== 'object' || value === null) {
            result[key] = value;
        }
    }
    return result;
}

const renders = (text, record) => {
    const obj = {
        children: text,
        props: {},
    };
    if (record.regionName == '整体团队汇总') {
        obj.props.colSpan = 0;
    }
    return obj;
}

class Filter extends Component {
    render() {
        const { curRole } = sessionStorage;
        const { workType, workContent, params, ...rest } = this.props;
        const filters = [{
            name: '时间',
            key: 'begin',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '至',
            key: 'end',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }];
        // if (curRole === 'BO') {
        //     filters.push({
        //         name: '团队领导',
        //         key: 'teamLeader',
        //         type: 'searchRetrieve',
        //         typeProperty: {
        //             keyword: 'nameCode',
        //             style: {width: 160},
        //             placeholder: '输入姓名或工号检索',
        //             params: {limit: 20},
        //             url: API_URL.user.getAllCRCDeptUserList,
        //             config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' },
        //         }
        //     });
        // }
        filters.push({
            name: '城市',
            key: 'cityIds',
            type: 'selectProvince',
            typeProperty: {
                selectCity: true,
            }
        });
        return (
            <FilterBasic filters={filters} params={params} {...rest} />
        )
    }
}

class CompareByCity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.search !== this.props.search) {
            const { pagination } = this.state;
            pagination.current = 1;
            this.setState({ pagination }, () => {
                this.loadData();
            });
        }
    }

    loadData = () => {
        const { searchParams } = this.props;
        const { sortParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = splitParams(searchParams);
        const options = {
            method: 'POST',
            url: API_URL.user.queryOutputRateByCity,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...params,
                crcUserId: sessionStorage.userId,
                relatedUser: 0,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                const data = (datas || []).map((item, index) => {
                    const { outputDate, outputRateView, regionName } = item;
                    if (regionName != '整体团队汇总') {
                        return {
                            title: ((current - 1) || 0) * pageSize + index + 1,
                            ...item,
                            ...outputRateView,
                            outputDate,
                        };
                    } else if (regionName == '整体团队汇总') {
                        return {
                            title: regionName,
                            ...item,
                            ...outputRateView,
                            outputDate,
                        };
                    }
                });
                this.setState({
                    data,
                    pagination,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'title',
            key: 'title',
            fixed: 'left',
            width: 60,
            render: (text, record) => {
                const obj = {
                    children: text,
                    props: {},
                };
                if (record.regionName == '整体团队汇总') {
                    obj.children = <div style={{ textAlign: 'right', fontWeight: 'bold' }}>{text}</div>;
                    obj.props.colSpan = 3;
                }
                return obj;
            }
        }, {
            title: '时间',
            dataIndex: 'outputDate',
            key: 'outputDate',
            fixed: 'left',
            width: 85,
            render: renders,
        }, {
            title: '城市',
            dataIndex: 'regionName',
            key: 'regionName',
            fixed: 'left',
            width: 85,
            render: renders,
        }, {
            title: '项目情况（临床部所有职位）',
            children: [{
                title: '项目确认FTE',
                dataIndex: 'invPositionAllConsumeFte',
                key: 'invPositionAllConsumeFte',
                width: 100,
            }, {
                title: '人数',
                dataIndex: 'invPositionAllPersonNum',
                key: 'invPositionAllPersonNum',
                width: 80,
                render: (text, record) => {
                    return <span style={{ color: '#49a9ee', cursor: 'pointer' }} onClick={() => this.showView(record, { type: 'invPositionAll' })}>{text}</span>
                }
            }, {
                title: '工作周期(h)',
                dataIndex: `invPositionAllWorkHour`,
                key: `invPositionAllWorkHour`,
                width: 80,
            }, {
                title: '人员产出率',
                dataIndex: 'invPositionAllOutputRate',
                key: 'invPositionAllOutputRate',
                width: 120,
            }, {
                title: '访视数',
                dataIndex: 'invPositionAllVisitCount',
                key: 'invPositionAllVisitCount',
                width: 80,
            }, {
                title: 'CRC项目确认FTE',
                dataIndex: 'invAllCrcConsumeFte',
                key: 'invAllCrcConsumeFte',
                width: 110,
            }, {
                title: '确认标准访视数',
                dataIndex: 'invAllStandardVisitCount',
                key: 'invAllStandardVisitCount',
                width: 80,
            }, {
                title: (
                    <span>
                        访视效率
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'确认标准访视数/CRC项目确认FTE'}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px', color: "#108EE9" }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'invPositionAllVisitRate',
                key: 'invPositionAllVisitRate',
                width: 120,
            }, {
                title: '方案违背数',
                dataIndex: 'invPositionAllViolationCount',
                key: 'invPositionAllViolationCount',
                width: 90,
            }]
        }, {
            title: '项目情况（临床协调员）',
            children: [{
                title: '项目确认FTE',
                dataIndex: 'invPositionCrcConsumeFte',
                key: 'invPositionCrcConsumeFte',
                width: 100,
            }, {
                title: '人数',
                dataIndex: 'invPositionCrcPersonNum',
                key: 'invPositionCrcPersonNum',
                width: 80,
                render: (text, record) => {
                    return <span style={{ color: '#49a9ee', cursor: 'pointer' }} onClick={() => this.showView(record, { type: 'invPositionCrc' })}>{text}</span>
                }
            }, {
                title: '工作周期(h)',
                dataIndex: `invPositionCrcWorkHour`,
                key: `invPositionCrcWorkHour`,
                width: 80,
            }, {
                title: '人员产出率',
                dataIndex: 'invPositionCrcOutputRate',
                key: 'invPositionCrcOutputRate',
                width: 120,
            }, {
                title: '访视数',
                dataIndex: 'invPositionCrcVisitCount',
                key: 'invPositionCrcVisitCount',
                width: 80,
            }, {
                title: 'CRC项目确认FTE',
                dataIndex: 'invPositionRoleCrcConsumeFte',
                key: 'invPositionRoleCrcConsumeFte',
                width: 110,
            }, {
                title: '确认标准访视数',
                dataIndex: 'invPositionStandardVisitCount',
                key: 'invPositionStandardVisitCount',
                width: 80,
            }, {
                title: (
                    <span>
                        访视效率
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'确认标准访视数/CRC项目确认FTE'}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px', color: "#108EE9" }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'invPositionCrcVisitRate',
                key: 'invPositionCrcVisitRate',
                width: 120,
            }, {
                title: '方案违背数',
                dataIndex: 'invPositionCrcViolationCount',
                key: 'invPositionCrcViolationCount',
                width: 90,
            }]
        }, {
            title: '项目情况（新临床协调员）',
            children: [{
                title: '项目确认FTE',
                dataIndex: 'invNewCrcConsumeFte',
                key: 'invNewCrcConsumeFte',
                width: 100,
            }, {
                title: '人数',
                dataIndex: 'invNewCrcPersonNum',
                key: 'invNewCrcPersonNum',
                width: 80,
                render: (text, record) => {
                    return <span style={{ color: '#49a9ee', cursor: 'pointer' }} onClick={() => this.showView(record, { type: 'invPositionCrc', crcType: 'NEW_CRC' })}>{text}</span>
                }
            }, {
                title: '工作周期(h)',
                dataIndex: `invNewCrcWorkHour`,
                key: `invNewCrcWorkHour`,
                width: 80,
            }, {
                title: '人员产出率',
                dataIndex: 'invNewCrcOutputRate',
                key: 'invNewCrcOutputRate',
                width: 120,
            }, {
                title: '访视数',
                dataIndex: 'invNewCrcVisitCount',
                key: 'invNewCrcVisitCount',
                width: 80,
            }, {
                title: 'CRC项目确认FTE',
                dataIndex: 'invNewRoleCrcConsumeFte',
                key: 'invNewRoleCrcConsumeFte',
                width: 110,
            }, {
                title: '确认标准访视数',
                dataIndex: 'invNewCrcStandardVisitCount',
                key: 'invNewCrcStandardVisitCount',
                width: 80,
            }, {
                title: (
                    <span>
                        访视效率
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'确认标准访视数/CRC项目确认FTE'}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px', color: "#108EE9" }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'invNewCrcVisitRate',
                key: 'invNewCrcVisitRate',
                width: 120,
            }, {
                title: '方案违背数',
                dataIndex: 'invNewCrcViolationCount',
                key: 'invNewCrcViolationCount',
                width: 90,
            }]
        }, {
            title: '非项目情况（临床部所有职位）',
            children: [{
                title: '非项目确认FTE',
                dataIndex: 'dailyPositionAllConsumeFte',
                key: 'dailyPositionAllConsumeFte',
                width: 100,
            }, {
                title: '人数',
                dataIndex: 'dailyPositionAllPersonNum',
                key: 'dailyPositionAllPersonNum',
                width: 80,
                render: (text, record) => {
                    return <span style={{ color: '#49a9ee', cursor: 'pointer' }} onClick={() => this.showView(record, { type: 'dailyPositionAll' })}>{text}</span>
                }
            }, {
                title: '工作周期(h)',
                dataIndex: `dailyPositionAllWorkHour`,
                key: `dailyPositionAllWorkHour`,
                width: 80,
            }, {
                title: '人员产出率',
                dataIndex: 'dailyPositionAllOutputRate',
                key: 'dailyPositionAllOutputRate',
                width: 120,
            }]
        }, {
            title: '总情况（临床部所有职位）',
            children: [{
                title: '总FTE',
                dataIndex: 'totalConsumeFte',
                key: 'totalConsumeFte',
                width: 80,
            }, {
                title: '人数',
                dataIndex: 'totalPersonNum',
                key: 'totalPersonNum',
                width: 80,
                render: (text, record) => {
                    return <span style={{ color: '#49a9ee', cursor: 'pointer' }} onClick={() => this.showView(record, { type: 'total' })}>{text}</span>
                }
            }, {
                title: '工作周期(h)',
                dataIndex: `totalWorkHour`,
                key: `totalWorkHour`,
                width: 80,
            }, {
                title: '人员产出率',
                dataIndex: 'totalOutputRate',
                key: 'totalOutputRate',
                width: 120,
            }, {
                title: (
                    <span>
                        空余率
                        <Tooltip overlayStyle={{ width: 200 }} placement="topRight" title={'某月个人空余率 = (1-该月个人总FTE)/1*100% (若值小于0，取0)'}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'spareRate',
                key: 'spareRate',
                width: 90,
            }]
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showView = (record, params) => {
        this.props.showView(record, params);
    }

    render() {
        const { data, loading, pagination, sortParams } = this.state;
        return (
            <Spin spinning={loading}>
                <TableC
                    data={data}
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
            </Spin>
        );
    }
}

class CompareByMonth extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            headList: [],
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.search !== this.props.search) {
            const { pagination } = this.state;
            pagination.current = 1;
            this.setState({ pagination }, () => {
                this.loadData();
            });
        }
    }

    loadData = () => {
        const { searchParams } = this.props;
        const { sortParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = splitParams(searchParams);
        const options = {
            method: 'POST',
            url: API_URL.user.queryCityOutputRateByMonth,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...params,
                crcUserId: sessionStorage.userId,
                relatedUser: 0,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                const data = (datas || []).map((item, index) => {
                    const { regionName, outputRateViewList } = item;
                    let showOutputRateView = {};
                    (outputRateViewList || []).map((value, index) => {
                        const params = { ...value };
                        const { outputDate } = value;
                        Object.keys(value).forEach(i => {
                            params[`${outputDate}_${i}`] = value[i];
                        });
                        params[`outputDate_${index}`] = outputDate;
                        showOutputRateView = { ...showOutputRateView, ...params };
                    })
                    if (regionName != '整体团队汇总') {
                        return {
                            title: ((current - 1) || 0) * pageSize + index + 1,
                            ...item,
                            ...showOutputRateView,
                        };
                    } else if (regionName == '整体团队汇总') {
                        return {
                            title: regionName,
                            ...item,
                            ...showOutputRateView,
                        };
                    }
                });
                this.setState({
                    data,
                    pagination,
                    loading: false,
                    headList: res.data,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const { headList } = this.state;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
            render: (text, record) => {
                const obj = {
                    children: text,
                    props: {},
                };
                if (record.regionName == '整体团队汇总') {
                    obj.children = <div style={{ textAlign: 'right', fontWeight: 'bold' }}>{text}</div>;
                    obj.props.colSpan = 3;
                }
                return obj;
            }
        }, {
            title: '城市',
            dataIndex: 'regionName',
            key: 'regionName',
            fixed: 'left',
            width: 85,
            render: renders,
        }];
        (headList || []).map((item, index) => {
            const idx = Math.floor(index / 2);
            if (item.newCRC == "0") {
                columns.push({
                    title: `${item.title}`,
                    children: [{
                        title: '项目确认FTE',
                        dataIndex: `${item.outputDate}_invPositionCrcConsumeFte`,
                        key: `${item.outputDate}_invPositionCrcConsumeFte`,
                        width: 100,
                    }, {
                        title: '人数',
                        dataIndex: `${item.outputDate}_invPositionCrcPersonNum`,
                        key: `${item.outputDate}_invPositionCrcPersonNum`,
                        width: 80,
                        render: (text, record) => {
                            return <span style={{ color: '#49a9ee', cursor: 'pointer' }} onClick={() => this.showView(record, { type: 'invPositionCrc', index: idx })}>{text}</span>
                        }
                    }, {
                        title: '工作周期(h)',
                        dataIndex: `${item.outputDate}_invPositionCrcWorkHour`,
                        key: `${item.outputDate}_invPositionCrcWorkHour`,
                        width: 80,
                    }, {
                        title: '人员产出率',
                        dataIndex: `${item.outputDate}_invPositionCrcOutputRate`,
                        key: `${item.outputDate}_invPositionCrcOutputRate`,
                        width: 120,
                    }, {
                        title: '访视数',
                        dataIndex: `${item.outputDate}_invPositionCrcVisitCount`,
                        key: `${item.outputDate}_invPositionCrcVisitCount`,
                        width: 80,
                    }, {
                        title: 'CRC项目确认FTE',
                        dataIndex: `${item.outputDate}_invPositionRoleCrcConsumeFte`,
                        key: `${item.outputDate}_invPositionRoleCrcConsumeFte`,
                        width: 110,
                    }, {
                        title: '确认标准访视数',
                        dataIndex: `${item.outputDate}_invPositionStandardVisitCount`,
                        key: `${item.outputDate}_invPositionStandardVisitCount`,
                        width: 80,
                    }, {
                        title: (
                            <span>
                                访视效率
                                <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'确认标准访视数/CRC项目确认FTE'}>
                                    <a><Icon style={{ marginLeft: 6, fontSize: '14px', color: "#108EE9" }} type="info-circle-o" /></a>
                                </Tooltip>
                            </span>
                        ),
                        dataIndex: `${item.outputDate}_invPositionCrcVisitRate`,
                        key: `${item.outputDate}_invPositionCrcVisitRate`,
                        width: 120,
                    }, {
                        title: '方案违背数',
                        dataIndex: `${item.outputDate}_invPositionCrcViolationCount`,
                        key: `${item.outputDate}_invPositionCrcViolationCount`,
                        width: 90,
                    }]
                })
            } else {
                columns.push({
                    title: `${item.title}`,
                    children: [{
                        title: '项目确认FTE',
                        dataIndex: `${item.outputDate}_invNewCrcConsumeFte`,
                        key: `${item.outputDate}_invNewCrcConsumeFte`,
                        width: 100,
                    }, {
                        title: '人数',
                        dataIndex: `${item.outputDate}_invNewCrcPersonNum`,
                        key: `${item.outputDate}_invNewCrcPersonNum`,
                        width: 80,
                        render: (text, record) => {
                            return <span style={{ color: '#49a9ee', cursor: 'pointer' }} onClick={() => this.showView(record, { type: 'invPositionCrc', crcType: 'NEW_CRC', index: idx })}>{text}</span>
                        }
                    }, {
                        title: '工作周期(h)',
                        dataIndex: `${item.outputDate}_invNewCrcWorkHour`,
                        key: `${item.outputDate}_invNewCrcWorkHour`,
                        width: 80,
                    }, {
                        title: '人员产出率',
                        dataIndex: `${item.outputDate}_invNewCrcOutputRate`,
                        key: `${item.outputDate}_invNewCrcOutputRate`,
                        width: 120,
                    }, {
                        title: '访视数',
                        dataIndex: `${item.outputDate}_invNewCrcVisitCount`,
                        key: `${item.outputDate}_invNewCrcVisitCount`,
                        width: 80,
                    }, {
                        title: 'CRC项目确认FTE',
                        dataIndex: `${item.outputDate}_invNewRoleCrcConsumeFte`,
                        key: `${item.outputDate}_invNewRoleCrcConsumeFte`,
                        width: 110,
                    }, {
                        title: '确认标准访视数',
                        dataIndex: `${item.outputDate}_invNewCrcStandardVisitCount`,
                        key: `${item.outputDate}_invNewCrcStandardVisitCount`,
                        width: 80,
                    }, {
                        title: (
                            <span>
                                访视效率
                                <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'确认标准访视数/CRC项目确认FTE'}>
                                    <a><Icon style={{ marginLeft: 6, fontSize: '14px', color: "#108EE9" }} type="info-circle-o" /></a>
                                </Tooltip>
                            </span>
                        ),
                        dataIndex: `${item.outputDate}_invNewCrcVisitRate`,
                        key: `${item.outputDate}_invNewCrcVisitRate`,
                        width: 120,
                    }, {
                        title: '方案违背数',
                        dataIndex: `${item.outputDate}_invNewCrcViolationCount`,
                        key: `${item.outputDate}_invNewCrcViolationCount`,
                        width: 90,
                    }]
                })
            }
        });
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showView = (record, params) => {
        record = {
            ...record,
            outputDate: record[`outputDate_${params.index}`],
        };
        this.props.showView(record, params);
    }

    render() {
        const { data, loading, pagination, sortParams } = this.state;
        return (
            <Spin spinning={loading}>
                <TableC
                    data={data}
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
            </Spin>
        );
    }
}

class ByCity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            maxMonth: null,
            searchParams: {},
            curParams: {},
            panes: [{
                title: '相同月份按城市比较',
                key: 'compareByCity',
                content: null,
            }, {
                title: '相同城市按月份比较',
                key: 'compareByMonth',
                content: null,
            }],
            activeKey: '',
            search: null,
        };
    }

    componentDidMount() {
        const { userId, curRole } = sessionStorage;
        if (curRole === 'BO') {
            this.queryCurEmployeeCode(userId);
        } else {
            this.queryRecentRecordTime(); 
        }
    }

    queryCurEmployeeCode = userId => {
        const options = {
            method: 'POST',
            url: API_URL.user.getUserInfoDetail,
            data: { userId },
            dataType: 'json',
            doneResult: res => {
                const { searchParams } = this.state;
                const { employee: { userId, employeeName, employeeCode } } = res;

                searchParams.teamLeaderId = userId;
                searchParams.teamLeader = { value: userId, text: `${employeeName}[${employeeCode}]` };

                this.setState({
                    searchParams,
                    curParams: {...searchParams},
                }, () => {
                    this.queryRecentRecordTime();
                });
            },
        };
        $.sendRequest(options);
    }

    queryRecentRecordTime = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryRecentRecordTime,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { date } = res;
                const { searchParams } = this.state;
                const maxMonth = date || moment().format(monthFormat);
                searchParams.begin = maxMonth;
                searchParams.end = maxMonth;
                this.setState({
                    maxMonth,
                    searchParams,
                    curParams: {...searchParams},
                    activeKey: 'compareByCity',
                });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { searchParams } = this.state;
        this.setState({
            search: {},
            curParams: { ...searchParams },
        });
    }

    export = () => {
        this.exportRef.show();
    }

    handleFilterChange = (searchParams, key) => {
        this.setState({ searchParams });
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey });
    }

    showView = (record, params) => {
        this.viewRef.show(record, params);
    }

    render() {
        const { panes, search, activeKey, curParams, searchParams } = this.state;
        return (
            <div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    onChange={this.handleFilterChange}
                    buttons={[
                        <Button key="export" type="primary" onClick={this.export}>导出</Button>
                    ]}
                />
                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                    {
                        panes.map(pane =>
                            <TabPane tab={pane.title} key={pane.key}>
                                {
                                    activeKey === pane.key && (
                                        activeKey === 'compareByCity' ?
                                            <CompareByCity search={search} searchParams={curParams} showView={this.showView} />
                                        :
                                            <CompareByMonth search={search} searchParams={curParams} showView={this.showView} />
                                    )
                                }
                            </TabPane>
                        )
                    }
                </Tabs>
                <View cur="city" searchParams={curParams} ref={el => this.viewRef = el} />
                < ExportModal cur="city" searchParams={curParams} ref={el => this.exportRef = el} />
            </div>
        );
    }
}

export default ByCity;


// WEBPACK FOOTER //
// ./src/components/user/output/ByCity.js